<script setup lang="ts">
export type HeadingLevel = '1' | '2' | '3' | '4' | '5' | '6'

interface IProps {
  level?: HeadingLevel
  maxLines?: number
  is?: `h${HeadingLevel}` | 'span'
}

const props = withDefaults(
  defineProps<IProps>(),
  {
    level: '1',
  },
)
const { level, maxLines } = toRefs(props)
</script>

<script lang="ts">
export default defineComponent({
  name: 'HeadingV2',
})
</script>

<template>
  <Component
    :is="is ?? `h${level}`" class="break-words whitespace-normal font-inter font-bold" :class="[
      `heading-${level}`,
      maxLines && 'overflow-auto',
      maxLines && `line-clamp-${maxLines}`,
    ]"
  >
    <slot />
  </Component>
</template>

<style lang="scss" scoped>
.break-words {
  word-break: break-word;
}

.heading-1 {
  font-size: 32px;
  line-height: 120%;
}

.heading-2 {
  font-size: 24px;
  line-height: 120%;
}

.heading-3 {
  font-size: 20px;
  line-height: 120%;
}

.font-author{
  font-size: 20px;
  line-height: 175%;
  font-weight: 700;
}

@media screen and (min-width: 768px) {
  .md\:heading-1 {
    font-size: 32px;
    line-height: 120%;
  }

  .md\:heading-2 {
    font-size: 24px;
    line-height: 120%;
  }

  .md\:heading-3 {
    font-size: 20px;
    line-height: 120%;
  }
}
</style>
